import { useState } from 'react';
import { apiUpload, errorMessage } from '@/api/client';
import { Icon } from '@/components/icons';
import { str } from '@/utils/format';
import { mediaUrl } from '@/utils/mediaUrl';

export { mediaUrl };

export function ImagePicker({
  value,
  onChange,
  onNotify,
  label = 'الصورة',
}: {
  value: string;
  onChange: (url: string) => void;
  onNotify?: (message: string, ok?: boolean) => void;
  label?: string;
}) {
  const [uploading, setUploading] = useState(false);
  const preview = mediaUrl(value);

  async function onFile(fileList: FileList | null) {
    const file = fileList?.[0];
    if (!file) return;
    const body = new FormData();
    body.append('image', file);
    setUploading(true);
    const res = await apiUpload('/admin/upload-image', body);
    setUploading(false);
    if (!res.success) {
      onNotify?.(errorMessage(res, 'تعذر رفع الصورة.'), false);
      return;
    }
    const data = res.data && typeof res.data === 'object' ? (res.data as Record<string, unknown>) : {};
    const url = str(res.url ?? data.url, '');
    if (!url || url === '—') {
      onNotify?.('تعذر قراءة رابط الصورة.', false);
      return;
    }
    onChange(url);
    onNotify?.('تم رفع الصورة.', true);
  }

  return (
    <div className="image-picker">
      <span>{label}</span>
      <div className="image-picker-row">
        <div className="image-thumb">
          {preview ? <img src={preview} alt="" /> : <Icon name="package" size={20} />}
        </div>
        <label className="image-upload-btn">
          <Icon name="package" size={16} />
          {uploading ? 'رفع...' : 'رفع صورة'}
          <input
            type="file"
            accept="image/png,image/jpeg,image/webp"
            disabled={uploading}
            onChange={(e) => void onFile(e.target.files)}
          />
        </label>
      </div>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="أو رابط الصورة"
      />
    </div>
  );
}
